export const meta = {
  title: 'Terms of Service | PhotoCraft ArtCraft AI',
  description:
    'Terms for using photocraftartcraft.com, an independent guide to the open-source PhotoCraft and VectorCraft editors.',
  updated_at: '2026-10-22',
};

## About this site

photocraftartcraft.com ("the site") is an independent guide to PhotoCraft and VectorCraft, operated by PhotoCraft ArtCraft AI. By using the site you agree to these terms. If you don't agree, please don't use the site.

## Not affiliated

We aren't affiliated with, endorsed by or sponsored by ArtCraft, Storyteller or Adobe. PhotoCraft, VectorCraft and ArtCraft are trademarks of their respective owners. Adobe, Photoshop and Illustrator are trademarks of Adobe Inc. These names are used only to describe the software and to compare it.

## PhotoCraft and VectorCraft software

PhotoCraft and VectorCraft are developed by the ArtCraft team and distributed through the official GitHub releases under the MIT or Apache-2.0 license. Your use of them, including the online versions this site hosts, is governed by that license, not by these terms. Both are early-alpha software provided "as is" by their authors. Back up your work before you rely on them, and save often when you use the online editors.

## Accuracy of information

We try to keep download links, install steps, feature lists and comparisons accurate and up to date. Software and pricing change quickly, though, so we can't guarantee that every detail is current. Check the official sources linked on each page before making decisions.

## Accounts

If you create an account, keep your sign-in details secure. You're responsible for activity under your account. We may suspend accounts that abuse the site.

## Acceptable use

Don't attack, overload, scrape at abusive rates or try to break the site, and don't use it for anything unlawful.

## Limitation of liability

The site is provided "as is", without warranties. To the extent the law allows, we aren't liable for any loss that comes from using the site or third-party software linked from it.

## Changes and contact

We may update these terms, and the date at the top shows when they last changed. Questions: [support@photocraftartcraft.com](mailto:support@photocraftartcraft.com).
